// src/oura/ui/rowClick.ts

/**
 * A whole-row click for a row that cannot be one link or button (a table
 * row, a row with several controls): runs `open` unless the click landed on
 * a control of its own, or the person was selecting text. The row's own
 * button stays the keyboard way in, so this adds a target and takes none away.
 */
export function rowClick(open: () => void) {
    return (e: { target: EventTarget | null }) => {
        if (e.target instanceof Element && e.target.closest("a, button, input, select, textarea, label, [role='combobox'], [role='menuitem']")) return;
        if (window.getSelection()?.toString()) return;
        open();
    };
}
